module.exports = __webpack_public_path__ + "img/P150T_weapon_135.da62396d.png";